export default __webpack_public_path__ + "static/media/login-banner.291a3c51.png";